import moment from 'moment';

import { MigrationReport } from 'types';

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
const DATE_FORMAT = 'YYYY-MM-DD';
const EMPTY = '-';

export const formatReportDate = (value: string | null | undefined): string =>
  value ? moment(value).format(DATE_TIME_FORMAT) : EMPTY;

export const formatReportRange = (report: MigrationReport): string => {
  if (!report.fromDate && !report.toDate) return 'all';

  const from = report.fromDate ? moment(report.fromDate).format(DATE_FORMAT) : '...';
  const to = report.toDate ? moment(report.toDate).format(DATE_FORMAT) : '...';

  return `${from} - ${to}`;
};

export const formatCount = (value: number | null | undefined): string =>
  value === null || value === undefined ? EMPTY : String(value);

export const csvFilename = (report: MigrationReport): string =>
  report.s3Key?.split('/').pop() ?? `fabric_state_migration_report_${report.id}.csv`;
